import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { DateFormats } from 'src/app/core/models/enums/date-formats';
import { ICalendarModel, ICalendarObject } from 'src/app/core/models/interfaces/calendar-model';
import { DateTimeService } from 'src/app/core/services/date-time.service';
import { LanguageService } from 'src/app/core/services/lang.service';

@Component({
  selector: 'calendar',
  templateUrl: './calendar.component.html',
  styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit, OnChanges {
  @Input() selectionMode: "single" | "range" = "single"
  @Input() initialDate: Date = new Date()
  /**
   * selectionMode == "range" ? Array<Date> | Array<string> : Date | string
   */
  @Input() preSelected: Array<Date> | Array<string> | Date | string = ""
  /**
   * Takvimi bu ay dışında farklı bir aydan açmak için kullanılır
   */
  @Input() startDate: Date | string = null
  @Input() min: Date | string = null
  @Input() max: Date | string = null
  @Input() refresher: number = 0
  /**
   * takvime ek görsellik kazandırmak için
   * burada tanımlanan tarihlere takvimde style atanır
   */
  @Input() modelData: any

  @Output() monthChanged: EventEmitter<any> = new EventEmitter<any>()
  @Output() confirmed: EventEmitter<any> = new EventEmitter<any>()
  @Output() onRangeChange: EventEmitter<any> = new EventEmitter<any>()
  @Output() dayClicked: EventEmitter<any> = new EventEmitter<any>()

  currentYear: number = new Date().getFullYear()
  currentYearShort: number = new Date().getFullYear() % 100
  currentMonth: number = new Date().getMonth() // Ocak ayı 0 indexi olarak hesaplandı.
  today: number = new Date().getDate()
  todayObj: Date = new Date()
  monthObj: Array<any> = []
  weekTemplate = ["0", "1", "2", "3", "4", "5", "6"]
  monthsNameList: Array<string> = []; // ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"]
  loading: boolean = false;
  dateRange: Array<Date> = new Array<Date>();
  selectedDate: number = Date.now()
  showYearSelection: boolean = false;
  yearOptions: number[] = new Array(21).fill(2000).map((t, i) => t + i)
  constructor(private langService: LanguageService, public dateTimeService: DateTimeService) {
    this.monthsNameList = langService.getTranslation("monthsArray")

  }
  ngOnChanges(changes: SimpleChanges): void {
    if ((changes["refresher"] || changes["modelData"]) && this.modelData) {
      this.monthObj = this.getDaysInMonth(this.currentMonth, this.currentYear)
    }
  }

  ngOnInit() {
    let yearOptionsStart = this.currentYear - this.currentYear % 20

    this.yearOptions = new Array(21).fill(yearOptionsStart).map((t, i) => t + i)
    this.setSelectedDates()
    let date = new Date(this.initialDate);
    this.today = date.getDate()
    this.todayObj = new Date(date.setHours(0, 0, 0, 0))
    //eğer startDate == null ise 1 ocak 1970 dönüyor
    if (this.startDate) {
      if (!isNaN(new Date(this.startDate).getTime())) {
        date = new Date(this.startDate)
      }
    }
    this.currentYear = date.getFullYear()
    this.currentMonth = date.getMonth()
    this.monthObj = this.getDaysInMonth(this.currentMonth, this.currentYear)
  }
  getDaysInMonth(month, year) {

    var date = new Date(year, month, 1, 0, 0, 0, 0);
    var days = [];
    let weekDays = []
    while (date.getMonth() === month) {
      let newDate = new Date(date)
      if (newDate.getDay() >= 0 && newDate.getDay() <= 6) {
        //TODO burada modelData'daki dataya göre ikon legend eklemesi yapılacak.

        let singleModelData = null
        if (this.modelData)
          singleModelData = this.modelData[this.dateTimeService.formatDate(newDate, DateFormats.FULL_DATE_DASH_REVERSE)] as ICalendarModel

        weekDays[`${newDate.getDay() == 0 ? 6 : newDate.getDay() - 1}`] = {
          dateObj: new Date(new Date(date).setHours(0, 0, 0, 0)),
          hasIcon: singleModelData?.hasIcon,
          iconIsSrc: singleModelData?.iconIsSrc,
          iconName: singleModelData?.iconName,
          iconColor: singleModelData?.iconColor,
          hasLegend: singleModelData?.hasLegend,
          legendColor: singleModelData?.legendColor,
          day: newDate.getDate(),
          rangeSelect: this.selectionMode == "range",
          isAvailable: DateTimeService.isDateInRange(newDate, this.min, this.max) && !singleModelData?.isDisabled,
          prop: singleModelData?.prop
        } as ICalendarObject;
      }
      if (Object.keys(weekDays).reverse()[0] == "6") {
        days.push(weekDays)
        weekDays = []
      }
      date = new Date(date.setDate(newDate.getDate() + 1))
    }
    if (weekDays.length > 0) {
      days.push(weekDays);
      weekDays = []
    }
    if (days.length < 6) {
      let fillerArray = new Array(6 - days.length).fill([])
      fillerArray.forEach(el => days.push(el))
    }
    return days;
  }

  getDateInstance(): Date {
    return new Date(this.currentYear, this.currentMonth, 1)
  }

  previousMonth() {
    this.loading = true;
    let oldDate = this.getDateInstance()
    let newDate = new Date(oldDate.setMonth(--this.currentMonth))
    this.currentMonth = newDate.getMonth()
    this.currentYear = newDate.getFullYear()
    this.monthChanged.emit(newDate)
    this.monthObj = this.getDaysInMonth(this.currentMonth, this.currentYear)
    this.loading = false;
  }

  nextMonth() {
    this.loading = true
    let oldDate = this.getDateInstance()
    let newDate = new Date(oldDate.setMonth(++this.currentMonth))
    this.currentMonth = newDate.getMonth()
    this.currentYear = newDate.getFullYear()
    this.monthChanged.emit(newDate)
    this.monthObj = this.getDaysInMonth(this.currentMonth, this.currentYear)
    this.loading = false
  }

  dayClickEvent(prop: ICalendarObject) {
    if (prop.rangeSelect) {
      if (this.dateRange.length < 2) {
        this.dateRange.push(prop.dateObj)
        this.dateRange = this.dateRange.sort().reverse();
        this.onRangeChange.emit(this.dateRange)
      } else if (this.dateRange.length == 2) {
        if (this.dateRange[0] > prop.dateObj)
          this.dateRange[0] = prop.dateObj
        if (this.dateRange[1] < prop.dateObj)
          this.dateRange[1] = prop.dateObj
        this.onRangeChange.emit(this.dateRange)
      }
    } else {
      this.selectedDate = prop.dateObj.getTime()
      this.dayClicked.emit(prop)
    }
  }

  close() {
    this.confirmed.emit({ status: false, data: null })
  }

  clearRange() {
    this.dateRange = []
    this.onRangeChange.emit(this.dateRange)
  }
  confirmRange() {
    this.confirmed.emit({ status: true, data: this.dateRange })
  }

  checkIsInRange(prop: ICalendarObject) {
    if (this.selectionMode == 'range') {
      if (this.dateRange.length == 0)
        return "";
      if (this.dateRange.length == 1) {
        if (this.dateRange[0] == prop.dateObj)
          return "selected-for-range start-end"
      } else {
        if (this.dateRange[0] == prop.dateObj || this.dateRange[1] == prop.dateObj)
          return "selected-for-range start-end"
        if (this.dateRange[0] < prop.dateObj && this.dateRange[1] > prop.dateObj)
          return "selected-for-range"
      }
    } else if (this.selectionMode == 'single') {
      return this.selectedDate == prop.dateObj.getTime() ? "selected" : "nope"
    } else
      return "";
  }

  setSelectedDates() {
    if (this.selectionMode == 'range') {
      if (Array.isArray(this.preSelected) && this.preSelected.length >= 2) {
        this.preSelected.forEach(el => {
          if (DateTimeService.isDate(el))
            this.dateRange.push(new Date(el))
        })
      }
    } else if (this.selectionMode == 'single') {
      let date: Date = null
      if (typeof this.preSelected == 'string') {
        date = DateTimeService.getMoment(this.preSelected).toDate()
      } else if (Array.isArray(this.preSelected)) {
        date = new Date(this.preSelected[0])
      } else if (typeof this.preSelected == 'object') {
        if (DateTimeService.isDate(this.preSelected)) {
          date = new Date(this.preSelected)
        }
      }
      if (date)
        this.selectedDate = date.getTime()
    } else {

    }
  }
  previosYears() {
    let year = this.yearOptions[0] - 1
    let startYear = year - (year % 20)
    this.yearOptions = new Array(21).fill(startYear).map((t, i) => t + i)
  }
  forwardYears() {
    let year = this.yearOptions[0] + 21
    let startYear = year - (year % 20)
    this.yearOptions = new Array(21).fill(startYear).map((t, i) => t + i)
  }
  newSelectedYear
  selectionState: 'month' | 'year' = 'year'
  selectYear(item) {
    this.newSelectedYear = item;
    this.selectionState = 'month'
  }
  selectMonth(index: number) {
    let date = new Date(this.newSelectedYear, index, 1, 0, 0, 0, 0)
    this.currentYear = date.getFullYear()
    this.currentMonth = date.getMonth()
    this.showYearSelection = false;
    this.selectionState = 'year'
    this.monthObj = this.getDaysInMonth(this.currentMonth, this.currentYear)
    this.monthChanged.emit(date)
  }
}
